import { createTheme } from '@mui/material';

export const prismaTheme = createTheme({
    palette: {
        mode: 'dark',
        footer: {
            background: '#1a1a2e',
            text: '#C7D2FE',
        },
        background: {
            default: '#0f0f23', // Púrpura muy oscuro
            paper: '#1a1a2e', // Fondo ligeramente más claro para el papel
            card: '#1a1a2e',
            darkCard: '#1a1a2e',
            light: '#2d2d44', // Púrpura grisáceo para el fondo de los componentes
            darkContrast: '#2d2d44',
        },
        border: {
            light: 'rgba(199, 210, 254, 0.08)',
            main: 'rgba(199, 210, 254, 0.15)',
            dark: 'rgba(199, 210, 254, 0.25)',
            darkerLight: 'rgba(199, 210, 254, 0.35)',
            darker: 'rgba(199, 210, 254, 0.6)',
            accent: '#8B5CF6',
            accent2: '#bb86fc',
        },
        primary: {
            main: '#8B5CF6', // Púrpura vivo, buena visibilidad en dark mode
            light: '#A78BFA', // Púrpura claro, visible sobre fondo oscuro
            dark: '#7C3AED', // Púrpura más profundo para buen contraste
            contrastText: '#fff', // Texto blanco para buena lectura
        },
        secondary: {
            main: '#06B6D4', // Cian vibrante
            light: '#67E8F9',
            dark: '#0891B2',
        },
        tertiary: {
            main: '#FF5722',
            light: '#FF7043',
            dark: '#E64A19',
        },
        text: {
            primary: '#C7D2FE', // Azul claro para texto principal
            secondary: '#A5B4FC', // Azul más claro para texto secundario
            disabled: '#ffffff33',
        },
        success: {
            main: '#66BB6A',
            light: '#A5D6A7',
            dark: '#388E3C',
        },
        error: {
            main: '#EF5350',
            light: '#E57373',
            dark: '#D32F2F',
        },
        warning: {
            main: '#FFA726',
            light: '#FFB74D',
            dark: '#F57C00',
        },
        info: {
            main: '#29B6F6',
            light: '#4FC3F7',
            dark: '#0288D1',
        },
        divider: '#37474F', // Gris más oscuro para los divisores
        competitions: {
            laLiga: '#ff4b44',
            fifaFriendlies: '#4db7ad',
            championsLeague: '#1d6fb1',
            supercopaEspaña: '#F66A03',
            copaRey: 'rgb(229 184 105)',
            europaLeague: '#1a892d',
            euroClasificacion: '#158ec0',
            defaultColor: '#69b59f',
        },
        navbar: {
            default: '#0f0f23', // Púrpura muy oscuro
            paper: '#1a1a2e', // Fondo ligeramente más claro para el papel
            border: '#0f0f23',
            text: '#C7D2FE',
        },
        analitica: {
            main: '#0f0f23',
            contrastText: '#C7D2FE',
        },
        risks: {
            veryHigh: 'rgb(242 127 127)',
            high: 'rgb(208 172 108)',
            medium: '#dddddd',
            low: 'rgb(148 191 148)',
            veryLow: 'rgb(192 216 237)',
        },
        minutes: {
            veryHigh: '#2196f3',
            high: '#0C6',
            medium: '#ccc',
            low: '#F90',
            veryLow: '#d32f2f',
        },
        competitions: {
            laLiga: '#ff4b44',
            fifaFriendlies: '#4db7ad',
            championsLeague: '#1d6fb1',
            supercopaEspaña: '#F66A03',
            copaRey: 'rgb(229 184 105)',
            europaLeague: '#1a892d',
            euroClasificacion: '#158ec0',
            defaultColor: '#69b59f',
        },
    },
    boxShadows: {
        main: '0px 0px 10px 0px rgba(255, 255, 255, 0.08)',
        hover: '0px 0px 12px 0px rgba(255, 255, 255, 0.15)',
        active: '0px 0px 14px 0px rgba(255, 255, 255, 0.25)',
        disabled: '0px 0px 8px 0px rgba(255, 255, 255, 0.05)',
        selected: '0px 0px 16px 0px rgba(255, 255, 255, 0.3)',
    },
    info: {
        success: '#1e4620', // verde oscuro elegante
        warning: '#663c00', // ámbar oscuro
        error: '#5f2120', // rojo oscuro vino
        info: '#0b3954', // azul oscuro profundo
        default: '#2c3e50', // gris-azul neutro para fondo general
    },
    mercado: {
        up: '#6bd37d',
        down: '#f98383',
        default: '#ccc',
    },
    resultados: {
        win: '#1a572e9e',
        draw: '#d5c0505e',
        lose: '#9434348f',
    },
    resultadosBox: {
        win: 'rgb(0, 121, 61)',
        draw: 'rgb(212, 90, 0)',
        lose: 'rgb(186, 59, 59)',
    },
    tier: {
        tier1: '#ff4b44',
        tier2: '#4CAF50',
        tier3: '#1a892d',
        tier4: '#158ec0',
        tier5: '#1d6fb1',
        tier6: '#4db7ad',
        tier7: '#69b59f',
    },
    typography: {
        allVariants: {
            fontFamily: `'Barlow', sans-serif`,
            textTransform: 'none',
            fontSize: 16,
            color: '#C7D2FE',
            lineHeight: 1.5,
        },
        h1: {
            fontSize: '20px',
            fontWeight: 500,
            color: '#C7D2FE',
            marginBottom: '1rem',
            lineHeight: 1.2,
        },
        h2: {
            fontSize: '19px',
            fontWeight: 500,
            color: '#C7D2FE',
        },
        h3: {
            fontSize: '18px',
            fontWeight: 500,
            color: '#C7D2FE',
        },
        h4: {
            fontSize: '17px',
            fontWeight: 500,
            color: '#C7D2FE',
        },
        h5: {
            fontSize: '16px',
            fontWeight: 500,
            color: '#C7D2FE',
        },
        h6: {
            fontSize: '15px',
            fontWeight: 500,
            color: '#C7D2FE',
        },
        body1: {
            color: '#C7D2FE',
        },
        body2: {
            color: '#C7D2FE',
        },
    },
    components: {
        MuiTableRow: {
            styleOverrides: {
                root: ({ theme }) => ({
                    transition: 'background-color 0.3s ease',
                    '&:hover': {
                        backgroundColor: 'rgba(139, 92, 246, 0.15)', // púrpura más visible en dark mode
                        cursor: 'pointer',
                    },
                    border: `1px solid ${theme.palette.border.light}`,
                }),
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: ({ theme }) => ({
                    borderBottom: `1px solid ${theme.palette.border.light}`,
                }),
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: ({ theme }) => ({
                    backgroundColor: theme.palette.background.darkCard,
                }),
            },
        },
        MuiTableBody: {
            styleOverrides: {
                root: ({ theme }) => ({
                    backgroundColor: theme.palette.background.default,
                }),
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: ({ theme }) => ({
                    border: `1px solid ${theme.palette.border.light}`,
                }),
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    '--Paper-shadow': 'none',
                    '--Paper-overlay': 'none',
                    boxShadow: 'none',
                    backgroundImage: 'none',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#A78BFA',
                    textDecoration: 'none',
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    a: {
                        color: '#A78BFA',
                        textDecoration: 'none',
                    },
                },
            },
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    paddingLeft: '4px',
                    paddingRight: '4px',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#0f0f23',
                    color: '#C7D2FE',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    backgroundColor: '#0f0f23',
                    color: '#C7D2FE',
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    backgroundColor: '#0f0f23',
                    color: '#C7D2FE',
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    backgroundColor: '#0f0f23',
                    color: '#C7D2FE',
                },
            },
        },
    },
});
